import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e37ef66e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "component c-bl1" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "c-gy2 pb1" }, "Contact Us", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "c-gy1" }, [
  /*#__PURE__*/_createTextVNode("If you have an idea, need engineers or consulting, please feel free to contact us at "),
  /*#__PURE__*/_createElementVNode("span", { class: "c-gr" }, "officialcandcventures@gmail.com")
], -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactUsComponent',
  setup(__props) {

    
    function openNewTab(url: string) {
      window.open('http:'+url, '_blank');
    }
    
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}
}

})